import * as React from 'react';
import '../css/scrollable-panel.sass';
import style2object from '../utils/style-object';

interface ScrollablePanelProps {
  children: React.ReactNode;
  height?: string;
  theme?: 'night' | 'day';
}

export default function ScrollablePanel(props: ScrollablePanelProps) {
  const { theme = 'day' } = props;
  const viewportHeight = props.height ? style2object(props.height) : {};
  return (
    <div className={`scrollable-panel ${theme}`} style={viewportHeight}>
      {props.children}
    </div>
  );
}
